import AIAvatarIdle from '../../assets/AIAvatarIdle'
import AIAvatarThinking from '../../assets/AIAvatarThinking'
import AIAvatarError from '../../assets/AIAvatarError'
import styles from './HelpBotAIAvatar.module.scss'

const AVATAR_COMPONENTS = {
    idle: AIAvatarIdle,
    thinking: AIAvatarThinking,
    error: AIAvatarError,
}

/**
 * Custom AI Avatar with animated states
 * @param {'idle' | 'thinking' | 'error'} status - The bot status
 * @param {number} size - Avatar size in pixels (default: 40)
 * @param {string} className - Additional CSS class
 */
export const HelpBotAIAvatar = ({ status = 'idle', size = 40, className = '' }) => {
    const AvatarSvg = AVATAR_COMPONENTS[status] || AVATAR_COMPONENTS.idle

    const containerClassName = [styles.avatar, styles[status], className].filter(Boolean).join(' ')

    return (
        <div className={containerClassName} style={{ width: size, height: size }}>
            <AvatarSvg className={styles.icon} />
        </div>
    )
}
